/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMLoginLessSubmitPayload } from '@/data/types/GTM';

export const getGTMLoginLessSubmitEventData = (payload: GTMLoginLessSubmitPayload) => ({
	login_step: payload.login_step,
	auth_method: payload.auth_method,
	login_status: payload.login_status,
	login_origin: payload.login_origin,
	is_new_user: payload.is_new_user,
	...(payload.error_message ? { error_message: payload.error_message } : {}),
	...(payload.login_trigger ? { login_trigger: payload.login_trigger } : {}),
});
